<template>
    <div class="ui-popover-segment">
        <slot></slot>
    </div>
</template>
